import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { merge } from 'lodash-es';
import { ApiResponse } from "../../../classes/api-response";
import { SnackService } from "../../../services/snack.service";
import { Box } from "../../../model/box";
import { BoxesService } from "../../../services/boxes-service";
import { SimsService } from "../../../services/sims.service";
import { BoxInterfacesService } from "../../../services/box-interfaces.service";
import { Constants } from "../../../utils/constants";
import { UsersService } from "../../../services/users.service";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import { BoxCertificatesService } from "../../../services/box-certificates.service";
import { BoxCertificate } from "../../../model/box-certificate";

@Component({
  selector: 'aw-add-certificate-to-box',
  templateUrl: './add-certificate-to-box.component.html',
  styleUrls: ['./add-certificate-to-box.component.scss']
})
export class AddCertificateToBoxComponent implements OnInit {

  addCertificateToBoxForm: UntypedFormGroup;
  @Output() saved = new EventEmitter<void>();
  @Output() canceled = new EventEmitter<void>();
  loadingCertificates = false;
  saving = false;
  flag = false;
  generalError?: ApiResponse;
  entities = Constants.entities;
  certificatesStatuses = Constants.certificateStatuses;

  certificates: BoxCertificate[] = [];

  _box = new Box();
  selectedCertificate?: BoxCertificate;

  constructor(
    private boxService: BoxesService,
    private snackService: SnackService,
    private simsService: SimsService,
    private boxInterfacesService: BoxInterfacesService,
    private usersService: UsersService,
    private boxCertificatesService: BoxCertificatesService,
    @Inject(MAT_DIALOG_DATA) public data: Box,
  ) {

    this.addCertificateToBoxForm = new UntypedFormGroup(
      {

        certificate: new UntypedFormControl(
          null,
          []
        ),
      }
    );
  }



  @Input() set box(value: Box) {
    this._box = merge(new Box(), value);
  }

  ngOnInit(): void {
    this.loadingCertificates = true;


    this.boxCertificatesService.getAllBoxCertificates([this.certificatesStatuses.unassigned]).subscribe(certificates => {
      this.certificates = certificates;
      this.loadingCertificates = false;
    });
  }


  addCertificates(): void {
    this.saving = true;
    this.boxCertificatesService.associateCertificate(this._box?.id, this.selectedCertificate)
      .subscribe(
        () => {
          this.saving = false;
          this.snackService.success('Certificate associated!');
          this.saved.emit();
        },
        error => {
          this.saving = false;
          this.snackService.error(error.message);
          this.generalError = error;
        });
  }
}
